export const storage: Map<string, string> = new Map<string, string>();
